import React, { Component, Fragment } from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import { withRouter } from 'react-router';
import { compose, bindActionCreators as bind } from 'redux';

import GetInTouchFlow from '../components/RetirementConversionFlow/Flow';
import { mp, getCampaign } from '../constants/utils';
import Icon from '../components/shared/Icon';
import ClipLoader from 'react-spinners/ClipLoader';

import { Diagnostic } from '../data/ducks';
import Result from '../components/RetirementConversionFlow/Result';
import Text from '../components/shared/Text';
import QuestionReference from '../components/GoalsFlow/QuestionReference';
import { PENSION_PLAN_PRICE } from '../constants/constants';
import { palette } from '../constants/styles';

import styled, { css } from 'styled-components';
const API_URL =
  process.env.NODE_ENV === 'development'
    ? 'https://370d18e440d0.ngrok.io/form'
    : 'https://us-central1-finauta-twilio.cloudfunctions.net/finauta_twilio/form';

export const questionTypes = {
  NUMERIC: 'number',
  YESNO: 'yes-no',
  SELECTION: 'select',
};

const StyledLoaderContainer = styled.div`
  position: fixed;
  background-color: white;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  z-index: 1000;
`;

const GetInTouchSteps = [GetInTouchFlow];

const StyledButtonText = styled.p`
  font-weight: 600;
`;

class GetInTouchContainer extends Component {
  state = {
    currentStep: 0,
    isLoading: false,
  };

  componentWillMount = () => {
    const questions = [
      {
        label: '',
        value: '',
        questions: [
          {
            inputName: 'name',
            inputTextStyle: {
              fontSize: '1.35rem',
              lineHeight: '1.8',
              fontFamily: "'Poppins',sans-serif",
            },
            value: null,
            type: questionTypes.NUMERIC,
            textType: 'body2question',
            errorType: 'biggerError',
            isTextual: true,
            prepend: '',
            buttonText: <StyledButtonText>Continuar</StyledButtonText>,
            startText: 'Me llamo: ',
            // final: 'Continuar',
            endText: '',
            placeholder: 'Juan Pérez',
            isCurrency: false,
            maxDigits: 40,
            inputWidth: 8,
            validation: Yup.string().required('Este es un campo requerido'),
            // reference: (
            //   <Text type="biggerReference">Nos gusta llamar a las personas por su nombre</Text>
            // ),
          },
        ],
      },
    ];

    if (!this.props.match.params.email) {
      questions[0].questions.push({
        inputName: 'emailForm',
        textType: 'body2question',
        errorType: 'biggerError',
        inputTextStyle: {
          fontSize: '1.35rem',
          lineHeight: '1.8',
          fontFamily: "'Poppins',sans-serif",
        },
        base: true,
        prepend: '',
        endText: '',
        startText: 'Mi correo es: ',
        type: questionTypes.NUMERIC,
        isTextual: true,
        isCurrency: false,
        placeholder: 'tucorreo@ejemplo.com',
        maxDigits: 80,
        inputSpanWidth: 20,
        inputWidth: '250px',
        inputMaxWidth: 100,
        buttonText: <StyledButtonText>Continuar</StyledButtonText>,
        validation: Yup.string()
          .email('Debe ser un correo electrónico válido')
          .required('Este es un campo requerido'),
        reference: (
          <QuestionReference>
            <Text type="biggerReference" style={{ marginBottom: '5px', color: palette.darkerGray }}>
              A este correo enviaremos tu plan
            </Text>
          </QuestionReference>
        ),
      });
    }

    questions[0].questions.push({
      inputName: 'phone',
      textType: 'body2question',
      errorType: 'biggerError',
      inputTextStyle: {
        fontSize: '1.35rem',
        lineHeight: '1.8',
        fontFamily: "'Poppins',sans-serif",
      },
      value: '',
      type: questionTypes.NUMERIC,
      pattern: '[0-9]*',
      prepend: '+52 ',
      startText: 'Mi celular es: ',
      endText: '',
      placeholder: '',
      maxDigits: 10,
      inputWidth: 8,
      inputMaxWidth: 7,
      noThousandSeparator: true,
      validation: Yup.string()
        .matches(/^\d{10}$/, 'Debe contener exactamente 10 dígitos')
        .required('Este es un campo requerido'),
      reference: (
        <Text type="biggerReference" style={{ color: palette.darkerGray, marginBottom: '10px' }}>
          <Icon icon="lock" style={{ marginRight: '3px' }} color={palette.darkerGray} size={12} />
          <b>Información segura</b>. Sólo te contactaremos para tu diagnóstico
        </Text>
      ),
      disclaimer: (
        <QuestionReference>
          <Text
            type="biggerReference"
            styles={{ marginTop: '10px', marginBottom: '40px', color: palette.darkerGray }}
          >
            Al dar click en "Solicitar diagnóstico" estás aceptando los{' '}
            <a target="_blank" href="https://www.finauta.com/terminos">
              términos y condiciones
            </a>{' '}
            y el{' '}
            <a target="_blank" href="https://www.finauta.com/aviso">
              aviso de privacidad
            </a>{' '}
            de Finauta.
          </Text>
        </QuestionReference>
      ),
      buttonText: <StyledButtonText>→ Solicitar diagnóstico</StyledButtonText>,
    });

    this.setState({ questionnaire: questions, totalSteps: GetInTouchSteps.length });
  };

  componentDidMount = () => {
    window.location = 'https://www.finauta.com/diagnostico?l=1ref=old_form';
    mp('Form | Plan de pensión');
  };

  nextStep = () => {
    const { currentStep, totalSteps } = this.state;
    if (currentStep < totalSteps - 1) {
      this.setState((state) => ({ currentStep: state.currentStep + 1 }));
    }
  };

  handleStepSubmit = (data) => {
    mp('Form | Plan de pensión | Envia datos');
    this.setState({ isLoading: true });
    const plan_code = this.props.match.params.planLink ? this.props.match.params.planLink : '_';
    const referral = this.props.match.params.referralId ? this.props.match.params.referralId : '_';

    const options = data[0];

    axios
      .post(
        API_URL,
        JSON.stringify({
          emailForm: options.emailForm,
          name: options.name,
          phone: options.phone,
          plan_link: `https://app.finauta.com/retiro/res/73/${plan_code}`,
          referral,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        },
      )
      .then((response) => {
        mp('Form | Plan de pensión | Success');
        if (process.env.NODE_ENV === 'development') {
          console.log(`Success! Response: ${response}`);
        } else {
          window.location.replace(
            `https://app.finauta.com/felicidades/${options.phone}/${referral}/${plan_code}`,
          );
        }
      })
      .catch((err) => {
        mp('Form | Plan de pensión | Error');
        if (process.env.NODE_ENV === 'development') {
          console.log(`Error! Err: ${err}`);
        } else {
          window.location.replace('https://app.finauta.com/error');
          throw Error(err);
        }
      });
    this.nextStep();
  };

  render() {
    const CurrentStep = GetInTouchSteps[this.state.currentStep];
    const { isLoading } = this.state;
    return (
      <Fragment>
        {isLoading ? (
          <StyledLoaderContainer>
            <ClipLoader
              css={css`
                display: block;
                margin-left: auto;
                margin-right: auto;
                text-align: center;
                margin-top: 40%;
                border-width: 5px;
              `}
              size={40}
              color={'#123abc'}
            />
          </StyledLoaderContainer>
        ) : (
          <></>
        )}
        <CurrentStep
          nextStep={this.nextStep}
          onStepSubmit={this.handleStepSubmit}
          questionnaire={this.state.questionnaire}
          result={this.props.result}
          when={this.state.when}
          tool={this.props.match.params.tool}
        />
      </Fragment>
    );
  }
}

GetInTouchContainer.propTypes = {
  result: PropTypes.object,
};

GetInTouchContainer.defaultProps = {
  result: {},
};

const mapStateToProps = (state) => ({
  result: state.diagnostic.result,
});

const mapDispatchToProps = (dispatch) =>
  bind(
    {
      sendAvailabilityData: Diagnostic.Creators.sendAvailabilityDataRequested,
    },
    dispatch,
  );

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(GetInTouchContainer);
